/** Texte brut d'un livre, dans l'ordre de lecture, pour retrouver et classer les citations.
 *  Le résultat doit coller au texte que la page affiche : les entités HTML sont
 *  toutes décodées, qu'elles soient numériques (&#8211;) ou nommées (&ndash;, &laquo;).
 */

const NAMED_ENTITIES = {
  nbsp: " ",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  ndash: "–",
  mdash: "—",
  hellip: "…",
  laquo: "«",
  raquo: "»",
  lsquo: "'",
  rsquo: "'",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  quot: '"',
  apos: "'",
  amp: "&",
  lt: "<",
  gt: ">",
  oelig: "œ",
  OElig: "Œ",
  aelig: "æ",
  AElig: "Æ",
  ccedil: "ç",
  Ccedil: "Ç",
  eacute: "é",
  Eacute: "É",
  egrave: "è",
  Egrave: "È",
  ecirc: "ê",
  Ecirc: "Ê",
  euml: "ë",
  agrave: "à",
  Agrave: "À",
  acirc: "â",
  Acirc: "Â",
  icirc: "î",
  Icirc: "Î",
  iuml: "ï",
  ocirc: "ô",
  Ocirc: "Ô",
  ugrave: "ù",
  Ugrave: "Ù",
  ucirc: "û",
  Ucirc: "Û",
  uuml: "ü",
  yuml: "ÿ",
  shy: "",
  times: "×",
  deg: "°",
  euro: "€",
  copy: "©",
  reg: "®",
  trade: "™",
  sect: "§",
  para: "¶",
  middot: "·",
  bull: "•",
  prime: "′",
  Prime: "″",
};

let decoder = null;

function decodeWithDom(source) {
  if (typeof document === "undefined") return null;
  try {
    if (!decoder) decoder = document.createElement("textarea");
    decoder.innerHTML = source;
    const decoded = decoder.value;
    decoder.innerHTML = "";
    return decoded;
  } catch {
    return null;
  }
}

function decodeWithTable(source) {
  return source.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]*);/gi, (whole, body) => {
    if (body[0] === "#") {
      const code = body[1] === "x" || body[1] === "X" ? parseInt(body.slice(2), 16) : Number(body.slice(1));
      if (!Number.isFinite(code) || code <= 0 || code > 0x10ffff) return whole;
      try {
        return String.fromCodePoint(code);
      } catch {
        return whole;
      }
    }
    if (Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, body)) return NAMED_ENTITIES[body];
    return whole;
  });
}

export function decodeHtmlEntities(value) {
  const source = String(value || "");
  if (!source.includes("&")) return source;
  const viaDom = decodeWithDom(source);
  return viaDom == null ? decodeWithTable(source) : viaDom;
}

const BLOCK_END =
  /<\/(p|div|h[1-6]|li|blockquote|section|article|tr|header|footer|aside|pre|figcaption|td|th|dd|dt|caption|address)>/gi;

export function htmlToPlain(html) {
  return decodeHtmlEntities(
    String(html || "")
      .replace(/<!--[\s\S]*?-->/g, " ")
      .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, " ")
      .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, " ")
      .replace(/<svg\b[^>]*>[\s\S]*?<\/svg>/gi, " ")
      .replace(/<img\b[^>]*>/gi, " ")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(BLOCK_END, "\n")
      .replace(/<[^>]+>/g, "")
  );
}

export function chaptersToPlain(chapters) {
  return (Array.isArray(chapters) ? chapters : [])
    .map((chapter) => `${chapter?.title || ""}\n${htmlToPlain(chapter?.html || "")}`)
    .join("\n");
}
